import React from "react";
import moment from "moment";
import { colorWithOpacity } from "./CalendarConstants";
import { getEventColor } from "./CalendarUtils";

const EventBlock = ({ event, top, height, left, width, onTap }) => {
  const color = getEventColor(event);
  const displayHeight = Math.max(height, 24);
  const hPad = width > 30 ? 4 : 2;
  const hMargin = width > 30 ? 1 : 0;
  const borderWidth = width > 20 ? 3 : 2;

  const showTime = displayHeight >= 36;
  const fontSize = displayHeight < 36 ? 10 : 12;
  const maxLines = displayHeight < 36 ? 1 : displayHeight < 50 ? 2 : 3;

  const timeStr = showTime
    ? `${moment(event.start).format("HH:mm")} - ${moment(event.end).format("HH:mm")}`
    : null;

  return (
    <div
      onClick={(e) => { e.stopPropagation(); onTap(event); }}
      style={{
        position: "absolute",
        top,
        left: left + hMargin,
        width: width - hMargin * 2,
        height: displayHeight,
        backgroundColor: colorWithOpacity(color, 0.15),
        borderLeft: `${borderWidth}px solid ${color}`,
        borderRadius: 4,
        padding: `2px ${hPad}px 0`,
        cursor: "pointer",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div style={{
        fontSize,
        fontWeight: 600,
        color: colorWithOpacity(color, 0.9),
        lineHeight: 1.3,
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
      }}>
        {event.title}
        {timeStr && <div style={{ fontSize: 10 }}>{timeStr}</div>}
      </div>
    </div>
  );
};

export default React.memo(EventBlock);
